(() => {
  jQuery(document).ready(function ($) {
    var fastProcessingElem = $('.fast-processing');
    var fastProcessingText = $('.fast-processing-label-text');
    var fastProcessingOriginalText = fastProcessingText.html();
    var fastProcessingPrice = $('.fast-processing-label-price');

    $('#fast_processing').on('change', function () {
      var checked = $(this).is(':checked') ? 1 : 0;

      const feedback = document.querySelector('.js-fast-processing');

      fastProcessingElem.toggleClass('active', checked);
      fastProcessingText.html('Loading...');
      fastProcessingPrice.hide();

      $.ajax({
        type: 'POST',
        url: window.woocommerce_params.ajax_url,
        data: {
          action: 'fast_processing',
          checked: checked,
        },
        success: function (response) {
          // Handle success response
          if (response.success) {
            console.log('Fast processing updated successfully.');

            if (feedback) {
              if (checked) {
                feedback.style.display = 'flex';
              } else {
                feedback.style.display = 'none';
              }
            }

            fastProcessingElem.toggleClass('active', checked);

            // //If we are on checkout page, simply trigger the update_checkout event
            if (window.location.pathname === '/checkout/') {
              jQuery('body').trigger('update_checkout');
            }
            else {
              window.location.reload();
            }

            fastProcessingText.html(fastProcessingOriginalText);
            fastProcessingPrice.show();
          } else {
            console.error('Error updating fast processing:', response.data);
          }
        },
      });
    });
  });
})();
